import { createContext } from 'react';

const useCWPContext = createContext();
export default useCWPContext;
